module.exports = __webpack_public_path__ + "static/media/IMPORT_BULK_UPLOAD_ATHENA_WITH_VAT_PARTNER.6c1484cd.xlsx";